import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import truncate from 'lodash/truncate';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

import { Tooltip } from 'uikit/tooltips';

import styles from '../styles/uikitLayoutsBreadcrumb.module.scss';

const Breadcrumb = ({
  breadcrumb = { path: '', text: '' },
  isCurrentLocation = true,
  maxChars = 45,
  shouldShowAllAsActive = false,
  shouldShowDivider = true,
}) => {
  const isTruncated = breadcrumb.text?.length > maxChars;
  const truncatedText = truncate(breadcrumb.text, { length: maxChars });

  const getBreadcrumbEl = () => {
    if (!shouldShowAllAsActive && (!breadcrumb.path || isCurrentLocation)) {
      return (
        <span aria-current="page" className={styles.item}>
          {truncatedText}
        </span>
      );
    }

    return (
      <NavLink to={breadcrumb.path} exact className={classnames(styles.item, styles.itemIsActive)}>
        {truncatedText}
      </NavLink>
    );
  };

  const renderBreadcrumb = () => {
    if (!isTruncated) return getBreadcrumbEl();
    return <Tooltip content={breadcrumb.text}>{getBreadcrumbEl()}</Tooltip>;
  };

  const renderDividerIcon = () => {
    if (shouldShowDivider) {
      return (
        <div className={styles.divider} aria-hidden="true">
          <KeyboardArrowRight sx={{ height: 10, width: 10 }} />
        </div>
      );
    }
  };

  return (
    <li className={styles.element}>
      {renderBreadcrumb()}
      {renderDividerIcon()}
    </li>
  );
};

Breadcrumb.propTypes = {
  breadcrumb: PropTypes.shape({
    path: PropTypes.string,
    text: PropTypes.string,
  }),
  isCurrentLocation: PropTypes.bool,
  maxChars: PropTypes.number,
  shouldShowAllAsActive: PropTypes.bool,
  shouldShowDivider: PropTypes.bool,
};

export { Breadcrumb as BreadcrumbStorybook };
export default React.memo(Breadcrumb);
